import { render, staticRenderFns } from "./BetgameEditDescription.vue?vue&type=template&id=4dfe5236&scoped=true"
import script from "./BetgameEditDescription.vue?vue&type=script&lang=js"
export * from "./BetgameEditDescription.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditDescription.vue?vue&type=style&index=0&id=4dfe5236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe5236",
  null
  
)

export default component.exports